import Vue from 'vue';
import api from '../../api/emailCampaignSenders';
import * as types from '../mutation-types';

const T = types.default;

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getSenders: $state => Object.values($state.records),
  getSender: $state => id => $state.records[id],
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async fetch({ commit }) {
    commit(T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG, { isFetching: true });
    try {
      const { data } = await api.get();
      commit(T.SET_EMAIL_CAMPAIGN_SENDERS, data);
    } finally {
      commit(T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG, { isFetching: false });
    }
  },
  async create({ commit }, payload) {
    commit(T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG, { isCreating: true });
    try {
      const { data } = await api.create({ email_campaign_sender: payload });
      commit(T.ADD_EMAIL_CAMPAIGN_SENDER, data);
      return data;
    } finally {
      commit(T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG, { isCreating: false });
    }
  },
  async update({ commit }, { id, ...payload }) {
    commit(T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await api.update(id, { email_campaign_sender: payload });
      commit(T.UPDATE_EMAIL_CAMPAIGN_SENDER, data);
      return data;
    } finally {
      commit(T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG, { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit(T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG, { isDeleting: true });
    try {
      await api.delete(id);
      commit(T.REMOVE_EMAIL_CAMPAIGN_SENDER, id);
    } finally {
      commit(T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [T.SET_EMAIL_CAMPAIGN_SENDERS]($state, list) {
    $state.records = (list || []).reduce(
      (acc, s) => ({ ...acc, [s.id]: s }),
      {}
    );
  },
  [T.ADD_EMAIL_CAMPAIGN_SENDER]($state, s) {
    Vue.set($state.records, s.id, s);
  },
  [T.UPDATE_EMAIL_CAMPAIGN_SENDER]($state, s) {
    Vue.set($state.records, s.id, s);
  },
  [T.REMOVE_EMAIL_CAMPAIGN_SENDER]($state, id) {
    Vue.delete($state.records, id);
  },
  [T.SET_EMAIL_CAMPAIGN_SENDER_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
